import React from 'react';
import styled from '@emotion/styled';

const Error = styled('span')`
	background: #FEF1F0;
	border-radius: 0 5px 5px 5px;
	box-shadow: #999 1px 1px 2px;
	color: #CA372C;
	display: block;
	font-size: 13px;
	font-weight: bold;
	line-height: normal;
	overflow-wrap: break-word;
	padding: 0.5em 2em 0.5em 0.5em;
	position: relative;
	width: 200px;

	&:after {
		display: block;
		content: "×";
		font-size: 1.5em;
		position: absolute;
		right: 0.25em;
		top: 0;
	}

	@media only screen and (max-width: 760px) {
		position: relative;
		left: 0;
		max-width: 100%;
		margin-top: 10px;
	}
}`;

export default function StyledError(props) {
	return props.children ? <Error data-cy="error">{props.children}</Error> : null;
}
